<ng-container *transloco="let t">
<div class="row mb-2">
  @for (income of incomes; track income.guid; let i = $index) {
    <income-item #incomeItem [income]="income"
      (editClicked)="onIncomeEditClicked($event)"
      (deleteClicked)="onIncomeDeleted($event)"
      (editIncomeItemsClicked)="onEditIncomeItemsClicked($event)">
    </income-item>
  }
</div>
@if (incomes.length > 0) {
  <div class="row">
    <span style="text-align: right;" class="text-dark fw-bolder d-block fs-5 mb-4">{{ t('wizard.income.totalMonthlyIncome') }} {{totalIncome | currency}}</span>
  </div>
}
</ng-container>
